// // @flow
// import * as React from "react";
// import { Select } from "antd";
// import { StyledInputContainer } from "./styles";

// const { Option } = Select;

// export const SelectInput = (props) => {
//   function onChange(value) {}

//   function onBlur() {
//     console.log("blur");
//   }

//   function onFocus() {
//     console.log("focus");
//   }

//   function onSearch(val) {}

//   return (
//     <StyledInputContainer>
//       <Select
//         showSearch
//         bordered={false}
//         style={{ width: "100%" }}
//         placeholder="Select a person"
//         optionFilterProp="children"
//         onChange={onChange}
//         onFocus={onFocus}
//         onBlur={onBlur}
//         onSearch={onSearch}
//         filterOption={(input, option) => {
//           return (
//             option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//           );
//         }}
//       >
//         {props.OptionList ? (
//           props.OptionList
//         ) : (
//           <>
//             <Option value="jack">Jack</Option>
//             <Option value="lucy">Lucy</Option>
//             <Option value="tom">Tom</Option>
//           </>
//         )}
//       </Select>
//     </StyledInputContainer>
//   );
// };

import * as React from "react";
import { Select } from "antd";
import { StyledInputContainer } from "./styles";

const { Option } = Select;

export const SelectInput = ({ dataList = [], setSearchItem, valueName }) => {
  const [selectedValue, setSelectedValue] = React.useState();

  console.log(dataList, "dataList", valueName);

  function onChange(value, option) {
    setSelectedValue(value);
    if (setSearchItem) {
      setSearchItem(value);
    }
  }

  function handleReset() {
    setSelectedValue(undefined);
    if (setSearchItem) setSearchItem(""); // Reset in parent too
  }

  return (
    <StyledInputContainer style={{ position: "relative" }}>
      <Select
        showSearch
        allowClear // Built-in clear button in Select (optional)
        bordered={false}
        style={{ width: "100%" }}
        placeholder="Search item"
        optionFilterProp="children"
        value={selectedValue}
        onChange={onChange}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {dataList.length > 0 ? (
          dataList.map((item) => (
            <Option key={item.id} value={item.id}>
              {item[valueName] || item?.customer?.firstName}
            </Option>
          ))
        ) : (
          <Option disabled>No data available</Option>
        )}
      </Select>
    </StyledInputContainer>
  );
};
